<ece-btn-icon
  [title]="'circ.details.document.open' | i18n"
  [icon]="document.doc.isHyperlink ? 'hyperlink-open' : 'document-manager'"
  [text]="document.doc.name"
  (click)="onOpenDocument()">
</ece-btn-icon>
<span class="pull-right">
  <ece-btn-icon *ngIf="!document.doc.isHyperlink"
    [title]="'circ.details.document.download' | i18n"
    [icon]="'download'"
    (click)="onDownloadDocument()"></ece-btn-icon>
  <span>
    <ece-btn-delete
      [title]="'circ.details.document.remove' | i18n" [disabled]="!(document.canDelete() | async)" [hidden]="!(document.canDelete() | async)"
      (click)="onDeleteDocument()"></ece-btn-delete>
  </span>
</span>
